import React from "react";
import "./Footer.css";

function Footer() {
    return (

        <div className="footer">
            <p className="center">Clicky Game &copy;2020</p>
        </div>
    );
}

export default Footer;